// A retainer in the client-documents tree: its own paperwork, then its topics'.
//
// Opening it shows, in this order:
//   1. THE RETAINER'S OWN FILES — the signed contract and every renewal, plus the scans
//      of the monthly invoices. Not itself a fold: the contract is the thing you came
//      for, and a second click to reach it would defeat nesting it here at all. Same
//      call the client card's RetainerBlock makes.
//   2. ITS TOPICS — each folding down to the files filed against it.
//
// EACH SECTION APPEARS ONLY IF IT HOLDS SOMETHING. A retainer is on this page at all
// only because it or something beneath it has a file (the server prunes the rest), so
// one of the two sections is always there and an empty heading is never printed. The
// case that makes this worth doing is a retainer with no contract on file whose topics
// are full of coverage: it appears, as the path to them, with no hollow table on top.
import { useNavigate } from 'react-router-dom';
import he from '../../i18n/he';
import Collapsible from '../../components/Collapsible';
import StatusBadge from '../../components/StatusBadge';
import Button from '../../components/Button';
import DocumentTable from './DocumentTable';
import JobNode from './JobNode';

export default function RetainerNode({
  retainer, archived, open, onToggle, isJobOpen, onToggleJob,
}) {
  const navigate = useNavigate();

  return (
    <Collapsible
      level={2}
      open={open}
      onToggle={onToggle}
      title={retainer.title}
      badges={
        <>
          <StatusBadge kind="retainer" value={retainer.status} />
          {/* The whole subtree, not just this level — a closed fold has to say how much
              is inside it, and what is inside it includes its topics' files. */}
          <span className="badge gray">{he.clientDocuments.documentCount(retainer.fileCount)}</span>
        </>
      }
      meta={
        <Button small variant="subtle" onClick={() => navigate(`/retainers/${retainer.id}`)}>
          {he.clientCard.openRetainer}
        </Button>
      }
    >
      {retainer.files.length > 0 && (
        <>
          <h3>{he.clientDocuments.directDocuments}</h3>
          <DocumentTable files={retainer.files} archived={archived} />
        </>
      )}

      {retainer.jobs.length > 0 && (
        <>
          <h3>{he.clientDocuments.topicsHeading}</h3>
          {retainer.jobs.map((job) => (
            <JobNode
              key={job.id}
              job={job}
              archived={archived}
              open={isJobOpen(job.id)}
              onToggle={() => onToggleJob(job.id)}
            />
          ))}
        </>
      )}
    </Collapsible>
  );
}
